export default "__VITE_ASSET__BAV2FBri__"